/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_PickInputs */

const en_platform_team_pick = /** @type {(inputs: Platform_Team_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team size`)
};

const pl_platform_team_pick = /** @type {(inputs: Platform_Team_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wielkość zespołu`)
};

/**
* | output |
* | --- |
* | "Team size" |
*
* @param {Platform_Team_PickInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_pick = /** @type {((inputs?: Platform_Team_PickInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_PickInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_pick(inputs)
	return en_platform_team_pick(inputs)
});